var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.23 1H3C2.45 1 2 1.45 2 2V16.13C2 16.38 2.3 16.51 2.48 16.34L7.95 11.11C8.12 10.95 8 10.66 7.77 10.66H5.85C5.71 10.66 5.59 10.54 5.59 10.4V9.22C5.59 9.08 5.71 8.96 5.85 8.96H11.27C11.41 8.96 11.53 9.08 11.53 9.22V14.38C11.53 14.52 11.41 14.64 11.27 14.64H10.01C9.87 14.64 9.75 14.52 9.75 14.38V12.41C9.75 12.18 9.48 12.06 9.31 12.22L2.59 18.64C2.39 18.84 2.52 19.18 2.81 19.18H16.45C17 19.18 17.45 18.73 17.45 18.18V7C17.45 6.73 17.34 6.47 17.14 6.28L11.92 1.28C11.73 1.1 11.49 1 11.23 1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.4e89aead71c3857e764771aba26323f1.svg";
export { ForwardRef as ReactComponent };